/* eslint-disable unicorn/no-this-assignment */
/* eslint-disable no-console */
import SelectorEngine from '../../../utils/dom/selector-engine';
import EventHandler from '../../../utils/dom/event-handler';
import Request from '../../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';
import Manipulator from '../../../utils/dom/manipulator';

const CLICK_EVENT = 'click';

class AllResourceContentTemplate {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.officials-off-court-content-template');
		if (!this._wrapper) {
			return;
		}
		this.initEvents();
		this.state = {
			selectedCategories: []
		};
	}

	initEvents() {
		// Events on Tabs Changes and Searches

		const addBookmarkButton = SelectorEngine.findOne('.content-id-bookmark', this._wrapper);
		const removeBookmarkButton = SelectorEngine.findOne('.content-id-unbookmark', this._wrapper);
		const pageId = Manipulator.getDataAttribute(this._wrapper, 'page-id'); 

		EventHandler.on(addBookmarkButton, CLICK_EVENT, (event) => {
			this.addBookmark(event, pageId);
		});

		EventHandler.on(removeBookmarkButton, CLICK_EVENT, (event) => {
			this.removeBookmark(event, pageId);
		});
	}

	async removeBookmark(event, pageId) {
		// eslint-disable-next-line no-debugger
		event.preventDefault(); 
		startLoadingAnimation(true); 
		try {
			const apiUrl = '/api/coachdetails/unbookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') { 
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	async addBookmark(event, pageId) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const apiUrl = '/api/coachdetails/bookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') {
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
}
const globalResourceTemplate = new AllResourceContentTemplate();
export default globalResourceTemplate;
